
import React from 'react';
import { FileStack } from 'lucide-react';

const NoArticlesAvailable: React.FC = () => {
  return (
    <div className="glass-panel rounded-xl p-6">
      <div className="text-center text-muted-foreground py-6">
        <FileStack className="h-8 w-8 mx-auto mb-4 opacity-50" />
        <h3 className="text-lg font-medium mb-2">No Similar Articles Found</h3>
        <p className="max-w-md mx-auto">
          We couldn't find articles similar to the URL you provided. Try a different URL or crawl more content.
        </p>
      </div>
    </div>
  );
};

export default NoArticlesAvailable;
